import { motion } from "framer-motion";
import Navigation from "../../components/Navigation";
import PageHero from "../../components/PageHero";

// Get Help - Emergency Assistance Page
const EmergencyAssistancePage = () => {
  return (
    <div data-testid="emergency-assistance-page" className="min-h-screen bg-[#FAFAFA]">
      <Navigation />
      
      <PageHero 
        image="https://customer-assets.emergentagent.com/job_7b46b431-509a-4162-84d5-ce52c765da4c/artifacts/w9bxx6km_Line%20outside%20door.jpg"
        alt="Emergency Assistance"
      />

      {/* Content */}
      <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 
              data-testid="emergency-assistance-title"
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A1A1A] mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Emergency Assistance
            </h1>
            
            <div className="text-[#1A1A1A] text-base md:text-lg leading-relaxed space-y-6">
              <p>
                In crisis situations, Murphy's Giving Market may be able to offer limited financial support. If you are at immediate risk of losing your home, facing a utility shutoff, or have an emergency medical need, <span className="whitespace-nowrap">contact us at <a href="tel:267-322-1088" className="text-[#1877F2] hover:underline font-medium">267-322-1088</a>.</span> We will work to get you help.
              </p>
              <p>
                Documentation of financial need and crisis situation is required. Please note that Murphy's Giving Market cannot guarantee services or outcomes.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default EmergencyAssistancePage;
